"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customComponents = require("../../../../utils/customComponents");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* istanbul ignore next */
var ButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/ButtonRedirect/ButtonRedirect"));
  });
});
/* istanbul ignore next */

var ButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/ButtonDownload/ButtonDownload"));
  });
});
/* istanbul ignore next */

var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
});
/* istanbul ignore next */

var IconButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/IconButtonDownload/IconButtonDownload"));
  });
});
/* istanbul ignore next */

var IconButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/templates/IconButtonDialog/IconButtonDialog"));
  });
});
/* istanbul ignore next */

var ButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/templates/ButtonDialog/ButtonDialog"));
  });
});
var components = {
  ButtonRedirect: ButtonRedirect,
  ButtonDownload: ButtonDownload,
  ButtonDialog: ButtonDialog,
  IconButtonRedirect: IconButtonRedirect,
  IconButtonDownload: IconButtonDownload,
  IconButtonDialog: IconButtonDialog
};

var CardActions = function CardActions(_ref) {
  var content = _ref.content,
      rootClass = _ref.rootClass,
      disableSpacing = _ref.disableSpacing,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      style = _ref.style;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, _objectSpread({}, style));

  return /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    className: "".concat(styles.root, " ").concat(storyblokClass),
    disableSpacing: disableSpacing,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, content.map(function (component, key) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, (0, _customComponents.renderComponentsWithBridge)(components, component, key));
  }));
};

var _default = CardActions;
exports.default = _default;
CardActions.propTypes = {
  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: true | false
   * If true, the actions do not have additional margin.
   */
  disableSpacing: _propTypes.default.bool,

  /**
   * Content passed to render
   * can also render any customCompnent passed in
   * components:
    ButtonRedirect,
   */
  content: function content(props, propName, componentName) {
    var validComponents = ['ButtonRedirect'];
    return validComponents(props, propName, componentName, validComponents);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
CardActions.defaultProps = {
  rootClass: [],
  disableSpacing: false,
  content: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};